import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { custom } from '../custom';
import { svg } from '../assets/svg';
import { theme } from '../constants';
import { components } from '../components';
import { handleLogin } from '../services/handleLogin';
import { useDispatch } from 'react-redux';
import { store } from '../store';
import banner from '../assets/Headerbanner.png'

export const SignIn: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [rememberMe, setRememberMe] = useState<boolean>(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const renderHeader = () => (
<div className="relative w-full h-48 md:h-64">
      {/* پس‌زمینه تصویر */}
      <img
        src={banner} // مسیر تصویر
        alt="Header Background"
        className="w-full h-full object-cover"
      />
    </div>
  );

  const onLogin = async () => {
    setLoading(true); // شروع بارگذاری
    setError(null);  // پاک کردن پیام خطا
    const result = await handleLogin({ username, password}, dispatch, store.getState);

    setLoading(false); // پایان بارگذاری

    if (result.success) {
      // ذخیره توکن در localStorage اگر rememberMe فعال باشد
      if (rememberMe) {
        localStorage.setItem('token', result.message);  // یا هر داده‌ای که برای ذخیره توکن دارید
      }
      // اگر لاگین موفق بود، کاربر را به صفحه اصلی هدایت می‌کنیم
      navigate('/home');
    } else {
      // در صورت خطا، پیام خطا را نمایش می‌دهیم
      setError(result.message);
    }
  };

  const renderContent = (): JSX.Element => (
    <div style={{ padding: '50px 20px 20px 20px' }}>
      <div>
        <custom.InputField
          label="نام کاربری"
          icon={<svg.InputCheckSvg />}
          containerStyle={{ marginBottom: 20 }}
          placeholder="نام کاربری"
          value={username}
          onChange={(value: string) => setUsername(value)}

        />
        <custom.InputField
          label="رمز عبور"
          placeholder="••••••••"
          icon={<svg.EyeOffSvg />}
          value={password}
          onChange={(value: string) => setPassword(value)}
          containerStyle={{ marginBottom: 20 }}
        />
      </div>
      {/* نمایش پیغام خطا */}
      {error && (
        <p style={{ color: 'red', textAlign: 'center', marginBottom: 20 }}>
          {error}
        </p>
      )}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginBottom: 30,
        }}
      >
        {/* Remember me */}
        <div
          style={{
            margin: 0,
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row',
            cursor: 'pointer',
            justifyContent: 'space-between',
          }}
          onClick={() => {
            setRememberMe(!rememberMe);
          }}
        >
          <div
            style={{
              width: 18,
              height: 18,
              borderRadius: 5,
              border: '2px solid #E8EFF4',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {rememberMe && <svg.InputCheckSvg />}
          </div>
          <span
            style={{
              color: theme.colors.textColor,
              fontSize: 16,
              marginRight: 12,
              ...theme.fonts.Mulish_400Regular,
            }}
          >
            مرا به خاطر بسپار
          </span>
        </div>
      </div>
      <components.Button
        title={loading ? 'در حال ورود...' : 'ورود'}
        style={{ marginBottom: 20}}
        onClick={onLogin}
      />

      <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row' }}>
        <span
          style={{
            marginLeft: 4,
            ...theme.fonts.Mulish_400Regular,
            fontSize: 16,
            lineHeight: 1.3,
            color: theme.colors.textColor,
          }}
        >
          حساب کاربری ندارید؟
        </span>
        <span
          style={{
            ...theme.fonts.Mulish_400Regular,
            fontSize: 16,
            lineHeight: 1.3,
            cursor: 'pointer',
            color: theme.colors.mainColor,
          }}
          onClick={() => navigate('/SignUp')}
        >
          ثبت نام کنید.
        </span>
      </div>
    </div>
  );

  return (
    <>
      {renderHeader()}
      {renderContent()}
    </>
  );
};
